import * as React from 'react';
import { observer } from 'mobx-react';
import { DeleteCycleConfirmationModal } from 'nomst/Components/CycleSettings/deleteCycleConfirmationModal';

export interface IDeleteCycleButtonProps {
    onDeleteCycleClick: () => void;
}

export interface IDeleteCycleButtonState {
    isDeleteCycleConfirmationModalOpen: boolean;
}

export class DeleteCycleButton extends
    React.Component<IDeleteCycleButtonProps, IDeleteCycleButtonState> {
    constructor(props: IDeleteCycleButtonProps) {
        super(props);
        this.openDeleteCycleConfirmationModal = this.openDeleteCycleConfirmationModal.bind(this);
        this.closeDeleteCycleConfirmationModal = this.closeDeleteCycleConfirmationModal.bind(this);
        this.determineIsModalOpen = this.determineIsModalOpen.bind(this);
        this.state = {
            isDeleteCycleConfirmationModalOpen: false
        };
    }

    render(): React.ReactNode {
        return (
            <div className="nomst-delete-cycle">
                <button
                    className="nomst-delete-cycle__delete-link pxl-link"
                    onClick={this.openDeleteCycleConfirmationModal}
                >
                    Delete Cycle
                </button>
                <DeleteCycleConfirmationModal
                    closeModal={this.closeDeleteCycleConfirmationModal}
                    isModalOpen={this.determineIsModalOpen}
                    onDeleteCycleClick={this.props.onDeleteCycleClick}
                />
            </div>
        );
    }

    private openDeleteCycleConfirmationModal(): void {
        this.setState({
            isDeleteCycleConfirmationModalOpen: true
        });
    }

    private closeDeleteCycleConfirmationModal(): void {
        this.setState({
            isDeleteCycleConfirmationModalOpen: false
        });
    }

    private determineIsModalOpen(): boolean {
        return this.state.isDeleteCycleConfirmationModalOpen;
    }
}

export default observer(DeleteCycleButton);